import cn from 'classnames';
import { useRef, useState } from 'react';
import useClickOutside from 'src/hooks/useClickOutside/useClickOutside';
import { styles } from './BigProductCardShareButton.styles';
import BigProductCardShareDropdown from './BigProductCardShareDropdown';

export interface BigProductCardShareButtonProps {
  productName: string;
  onShowMessage(translationKey: string): void;
}

export default function BigProductCardShareButton(
  props: BigProductCardShareButtonProps,
) {
  const { productName, onShowMessage } = props;

  const dropdownRef = useRef(null);
  const [shareDropdownIsOpen, setsHareDropdownIsOpen] = useState(false);

  const toggleDropdown = () => {
    setsHareDropdownIsOpen((prev) => !prev);
  };

  useClickOutside(dropdownRef, () => {
    setsHareDropdownIsOpen(false);
  });

  return (
    <div className='BigProductCardShareButton' ref={dropdownRef}>
      <span
        role='button'
        onClick={toggleDropdown}
        aria-label='Share product'
        data-marker='share_product'
        className={cn('BigProductCardShareButton__icon icon-share', {
          BigProductCardShareButton__icon_active: shareDropdownIsOpen,
        })}
      />

      {shareDropdownIsOpen && (
        <BigProductCardShareDropdown
          onItemClick={toggleDropdown}
          productName={productName}
          onShowMessage={onShowMessage}
        />
      )}

      <style jsx>{styles}</style>
    </div>
  );
}
